import { ClockCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { REPORTING_CONSTANTS } from './reportingUtils/reportingAndAnalyticsConstants';

const AdoptionReport = (): React.ReactElement => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-card">
        <ClockCircleOutlined className="coming-soon-icon" />
        <h2 className="coming-soon-title">
          {REPORTING_CONSTANTS.ADOPTION_REPORT}
        </h2>
        <p className="coming-soon-text">{REPORTING_CONSTANTS.COMING_SOON}</p>
      </div>
    </div>
  );
};

export default AdoptionReport;
